import { useNotify, useRedirect } from "ra-core";
import { Box, Grid } from "@material-ui/core";

import LeftGridEdit from "../components/LeftGridEdit";
import LayoutContainer from "../components/LayoutContainer";
import TextInputRA from "../components/TextInputRA";
import RightGridEdit from "../components/RightGridEdit";
import GeneralSelect from "../components/GeneralSelect";
import StatusInput from "../components/StatusInput";
import PaymentChannelEditValidation from "../../../ValidationRules/PaymentChannelEditValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import { Loading } from "react-admin";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const transform = (data) => {
  return {
    ...data,
    institute_id: data.institute.id,
    payment_method_id: data.payment_method.id,
  };
};

const PaymentMethodEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.Payment_Method",
    write: true,
  });
  if (loading) return <Loading />;
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          transform={transform}
          {...props}
          validate={PaymentChannelEditValidation}
          disabled={!allow}
        >
          <SfBreadcrumbs path="Management/Payment methods/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Channel name" source="name" />
            <TextInputRA label="Description" source="desc" />
            <TextInputRA label="Account no." source="account_no" />
            <TextInputRA label="Account name." source="account_name" />
            <TextInputRA label="Action code" source="action_code" />

            <GeneralSelect
              require
              label="Institute"
              source="institute.id"
              resource="institutes"
            />
            <GeneralSelect
              require
              label="Payment Method"
              source="payment_method.id"
              resource="payment-methods"
            />
            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit {...props} resource={"payment-channels"} />
      </Grid>
    </LayoutContainer>
  );
};

export default PaymentMethodEdit;
